import React, { useEffect, useState } from 'react';
import UiIcon from './UiIcon';
import { formatDate, MONTHS_FI } from '../../utils/dateUtils';

// Sidebar month grid shared by the Terälehti and Nono editors (Monday first, Finnish labels).
// renderDay(id, dayNumber) returns the day button; children go under the grid.
// On narrow screens (CSS) the calendar folds into one bar that closes itself when a day is picked.
export default function MonthCalendar({ month, onMonthChange, renderDay, selectedId, children }) {
  const [open, setOpen] = useState(true);
  useEffect(() => { if (selectedId) setOpen(false); }, [selectedId]);

  const year = month.getFullYear();
  const monthIndex = month.getMonth();
  const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
  const leadingBlanks = (new Date(year, monthIndex, 1).getDay() + 6) % 7;
  return (
    <aside className={`tl-calendar ${open ? 'open' : ''}`}>
      <button type="button" className="tl-calendar-toggle" aria-expanded={open} onClick={() => setOpen(o => !o)}>
        <UiIcon name="calendar_month" />
        <span>{selectedId ? selectedId.split('-').reverse().join('.') : 'Valitse päivä'}</span>
        <UiIcon name={open ? 'expand_less' : 'expand_more'} />
      </button>
      <div className="tl-calendar-body">
        <div className="tl-month-header">
          <button className="btn-secondary" onClick={() => onMonthChange(new Date(year, monthIndex - 1, 1))} aria-label="Edellinen kuukausi"><UiIcon name="chevron_left" /></button>
          <h3>{MONTHS_FI[monthIndex]} {year}</h3>
          <button className="btn-secondary" onClick={() => onMonthChange(new Date(year, monthIndex + 1, 1))} aria-label="Seuraava kuukausi"><UiIcon name="chevron_right" /></button>
        </div>
        <div className="tl-days">
          {['ma', 'ti', 'ke', 'to', 'pe', 'la', 'su'].map(d => <div key={d} className="tl-weekday">{d}</div>)}
          {Array.from({ length: leadingBlanks }).map((_, i) => <div key={`b${i}`} />)}
          {Array.from({ length: daysInMonth }).map((_, i) => renderDay(formatDate(new Date(year, monthIndex, i + 1)), i + 1))}
        </div>
        {children}
      </div>
    </aside>
  );
}
